import React, { ReactNode } from 'react';

import Content from '../../../BaseModal/components/Content/Content';

import { ChildrenWrapper, Wrapper } from './Sidebar.styled';
import { SidebarMenu } from './components/Menu/Menu';

export interface SidebarProps {
  children?: ReactNode;
}

export const Sidebar = ({ children }: SidebarProps) => (
  <Wrapper>
    <Content>
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Content>
  </Wrapper>
);

Sidebar.Menu = SidebarMenu;
